<nav class="productNav"
     ngClass.lt-sm="productNav-sm">
  <button *ngIf="offerBundlesSummary?.bestLocOfferBundle"
          (click)="onClickProduct(offerBundlesSummary.bestLocOfferBundle)"
          [ngClass]="{active: isCurrentLocProduct}">
    <mat-icon>data_saver_off</mat-icon>
    <div>
      LINE OF CREDIT
    </div>
  </button>
  <button *ngIf="offerBundlesSummary?.bestLargeLoanProgramOfferBundle"
          (click)="onClickProduct(offerBundlesSummary.bestLargeLoanProgramOfferBundle)"
          [ngClass]="{active: isCurrentLargeLoanProgramProduct}">
    <mat-icon>workspace_premium</mat-icon>
    <div class="product-name">
      {{largeLoanProgramName}}
    </div>
  </button>
  <button *ngIf="offerBundlesSummary?.bestLawOfferBundle"
          (click)="onClickProduct(offerBundlesSummary.bestLawOfferBundle)"
          [ngClass]="{active: isCurrentLawProduct}">
    <mat-icon>assessment</mat-icon>
    <div>
      CASE FINANCING
    </div>
  </button>
  <button *ngIf="offerBundlesSummary?.bestTermOfferBundle"
          (click)="onClickProduct(offerBundlesSummary.bestTermOfferBundle)"
          [ngClass]="{active: isCurrentTermProduct}">
    <mat-icon>assessment</mat-icon>
    <div>
      TERM LOAN
    </div>
  </button>
</nav>
